import { z } from 'zod';
export const ApiErrorCodeSchema = z.enum([
    'BAD_REQUEST',
    'UNAUTHORIZED',
    'FORBIDDEN',
    'NOT_FOUND',
    'CONFLICT',
    'VALIDATION_ERROR',
    'INTERNAL_ERROR',
    'SERVICE_UNAVAILABLE',
]);
export const ApiErrorDetailSchema = z.object({
    code: ApiErrorCodeSchema,
    message: z.string(),
    details: z.unknown().optional(),
    requestId: z.string().optional(),
});
export const ApiErrorEnvelopeSchema = z.object({
    success: z.literal(false),
    error: ApiErrorDetailSchema,
});
export function createSuccessEnvelopeSchema(dataSchema) {
    return z.object({
        success: z.literal(true),
        data: dataSchema,
        meta: z.record(z.unknown()).optional(),
    });
}
//# sourceMappingURL=errors.js.map